// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*  imported from Rating.module.scss  */
.Rating-module-Rating_2LC {
  display: inline-flex; }

/* Sizes */
.Rating-module-sSize_2yq {
  font-size: 1rem; }
  .Rating-module-sSize_2yq .Rating-module-Star_BF2:not(:last-child) {
    margin-right: 0.125em; }

.Rating-module-mSize_3vQ {
  font-size: 1.5rem; }
  .Rating-module-mSize_3vQ .Rating-module-Star_BF2:not(:last-child) {
    margin-right: 0.5em; }

.Rating-module-lSize_21k {
  font-size: 2.5rem; }
  .Rating-module-lSize_21k .Rating-module-Star_BF2:not(:last-child) {
    margin-right: 0.6em; }
`, "",{"version":3,"sources":["webpack://./node_modules/@npm-registry/eapteka-ui/es/components/Rating/Rating.css"],"names":[],"mappings":"AAAA,uCAAuC;AACvC;EACE,oBAAoB,EAAE;;AAExB,UAAU;AACV;EACE,eAAe,EAAE;EACjB;IACE,qBAAqB,EAAE;;AAE3B;EACE,iBAAiB,EAAE;EACnB;IACE,mBAAmB,EAAE;;AAEzB;EACE,iBAAiB,EAAE;EACnB;IACE,mBAAmB,EAAE","sourcesContent":["/*  imported from Rating.module.scss  */\n.Rating-module-Rating_2LC {\n  display: inline-flex; }\n\n/* Sizes */\n.Rating-module-sSize_2yq {\n  font-size: 1rem; }\n  .Rating-module-sSize_2yq .Rating-module-Star_BF2:not(:last-child) {\n    margin-right: 0.125em; }\n\n.Rating-module-mSize_3vQ {\n  font-size: 1.5rem; }\n  .Rating-module-mSize_3vQ .Rating-module-Star_BF2:not(:last-child) {\n    margin-right: 0.5em; }\n\n.Rating-module-lSize_21k {\n  font-size: 2.5rem; }\n  .Rating-module-lSize_21k .Rating-module-Star_BF2:not(:last-child) {\n    margin-right: 0.6em; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
